import {
  KoForm,
  KoFormBuilder,
  KoInput,
  KoSelect
} from 'packages';
import { ENVIRONMENT_TYPE_OPTIONS } from '../../constants';

function EnvironmentCrud({ form, handleFinish }) {
  const TypeWidget = ({ value, onChange }) => (
    <KoSelect value={value} onChange={onChange} placeholder='Select type' options={ENVIRONMENT_TYPE_OPTIONS} />
  );

  const meta = {
    columns: 4,
    formItemLayout: null,
    colon: true,
    fields: [
      { key: 'name', label: 'Environment Name', colSpan: 2, widget: KoInput, required: true, widgetProps: { placeholder: 'e.g. Production' } },
      { key: 'type', label: 'Type', colSpan: 2, widget: TypeWidget, forwardRef: true, required: true },
      { key: 'baseUrl', label: 'Base URL', colSpan: 4, widget: KoInput, widgetProps: { placeholder: 'https://api.example.com' } },
      { key: 'description', label: 'Description', colSpan: 4, widget: KoInput.TextArea, widgetProps: { rows: 2, placeholder: 'Environment description...' } }
    ]
  };

  return (
    <KoForm form={form} layout='vertical' onFinish={handleFinish}>
      <KoFormBuilder form={form} meta={meta} />
    </KoForm>
  );
}

export default EnvironmentCrud;
